import React from 'react';

export default function AbilityIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      {/* Lightning bolt in circle - abilities/powers */}
      <circle cx="12" cy="12" r="9.5" stroke={color} strokeWidth="1.5" fill={color} opacity="0.12" />
      <path
        d="M13 3.5L7.5 13h4l-1 7.5L17 10h-4l1-6.5z"
        fill={color}
        opacity="0.85"
      />
    </svg>
  );
}
